import { Alert } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { DateTimeInput, isFutureDate } from 'utils/dateParsing';

export const FutureServiceDateAlert = ({
  serviceStarts,
  timezone,
}: {
  serviceStarts: DateTimeInput[];
  timezone: string | null | undefined;
}) => {
  const futureServiceStartCount = serviceStarts.filter((serviceStart) =>
    isFutureDate(serviceStart, timezone)
  ).length;

  if (futureServiceStartCount === 0) return null;

  return (
    <Alert
      title="Future service date"
      color="yellow"
      radius="sm"
      icon={<IconAlertTriangle size={18} />}
      data-testid="future-service-date-alert"
    >
      {futureServiceStartCount === 1
        ? 'This claim has a service date in the future. Please verify it before saving.'
        : `${futureServiceStartCount} claims have service dates in the future. Please verify them before saving.`}
    </Alert>
  );
};
